import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate,
} from '@angular/material/datepicker';
import {
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { NavigationService } from '@jfw/angular/ecommerce/core';
import { convertDateToUnixTimestamp } from '@jfw/business-logic';
import { Subscription } from 'rxjs';

interface SearchForm {
  eventDateStart: FormControl<Date | null>;
  eventDateEnd: FormControl<Date | null>;
  eventName: FormControl<string | null>;
}

@Component({
  selector: 'app-event-search',
  templateUrl: './event-search.component.html',
  styleUrls: ['./event-search.component.scss'],
  imports: [
    NgClass,
    MatIconButton,
    MatIcon,
    ReactiveFormsModule,
    MatLabel,
    MatFormField,
    MatDateRangeInput,
    MatStartDate,
    MatEndDate,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    MatInput,
    MatButton,
  ],
})
export class EventSearchComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  public showDrawer = false;
  public isMobile = false;
  public animation: 'open' | 'close' | '' = 'close';

  public searchForm = new FormGroup<SearchForm>({
    eventDateStart: new FormControl<Date | null>(null),
    eventDateEnd: new FormControl<Date | null>(null),
    eventName: new FormControl<string | null>(null),
  });

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.navigationService.showSearchDrawer$.subscribe({
        next: (showSearchDrawer) => {
          this.showDrawer = showSearchDrawer;
          this.setAnimation();
        },
      }),
    );

    this.subscription.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe({
          next: (result) => {
            this.isMobile = result.matches;
            this.setAnimation();
          },
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setAnimation(): void {
    if (this.isMobile) {
      this.animation = '';
    } else {
      this.animation = this.showDrawer ? 'open' : 'close';
    }
  }

  public onToggleDrawer(): void {
    this.navigationService.showSearchDrawer(!this.showDrawer);
  }

  public onCloseNav(): void {
    this.navigationService.showSearchNav(false);
  }

  public onSubmit(): void {
    let eventDateStart: number | undefined;
    let eventDateEnd: number | undefined;

    const eventDateStartValue = this.searchForm.controls.eventDateStart.value;
    if (eventDateStartValue) {
      eventDateStart = convertDateToUnixTimestamp(
        eventDateStartValue.toString(),
      );
    }

    const eventDateEndValue = this.searchForm.controls.eventDateEnd.value;
    if (eventDateEndValue) {
      eventDateEnd = convertDateToUnixTimestamp(eventDateEndValue.toString());
    }

    const eventName = this.searchForm.controls.eventName.value ?? undefined;

    this.router.navigate(['/event-search'], {
      queryParams: {
        eventDateStart: eventDateStart,
        eventDateEnd: eventDateEnd,
        eventName: eventName,
      },
    });
  }
}
